import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Dismiss from '../__partials/dismiss';
import Button from '../buttons/button';
import Action from './action/';
import giveWarning from '../__utils/warning';

import './style.scss';

const ActionBar = ({ isOpen, infoText, actions, onClose, qaId }) => {
  const actionBarClasses = classNames('uni-actionbar', {
    'uni-actionbar--is-open': isOpen,
  });

  if (actions.type === Action || actions[0].type === Action) {
    giveWarning(
      'Passing in Action components is deprecated and will be removed in the next major ' +
        'release of uniform-ui-components. Use the shape documented on uniform.hudl.com instead.'
    );
  }

  return (
    <div className={actionBarClasses} data-qa-id={qaId}>
      <div className="uni-actionbar__container">
        <h4 className="uni-actionbar__info-text">{infoText}</h4>
        <div className="uni-actionbar__action-container">
          {actions.type === Action || actions[0].type === Action
            ? actions
            : actions.map((item, key) => (
              <Button
                size="medium"
                disabled={item.disabled}
                icon={item.icon}
                qaId={item.qaId}
                buttonRef={item.actionRef}
                onClick={item.onClick}
                key={key}
              >
                {item.label}
              </Button>
            ))}
        </div>
      </div>
      <Dismiss size="medium" className="uni-actionbar__dismiss" onClick={onClose} />
    </div>
  );
};

ActionBar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  infoText: PropTypes.node.isRequired,
  actions: PropTypes.oneOfType([
    PropTypes.objectOf(Action),
    PropTypes.arrayOf(Action),
    PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
        disabled: PropTypes.bool,
        qaId: PropTypes.string,
        actionRef: PropTypes.func,
        onClick: PropTypes.func.isRequired,
      })
    ),
  ]),
  onClose: PropTypes.func,
  qaId: PropTypes.string,
};

export default ActionBar;



// WEBPACK FOOTER //
// ./src/action-bar/index.jsx